import React from "react";

export function TravelAirportIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="travel-airport-departure-time--travel-plane-trip-airplane-time-off-adventure-timer-take-clock--Streamline-Core">
        <g id="Group">
          <path
            id="Vector"
            d="M12.4587 13.0165C11.9585 11.8422 11.7254 10.5714 11.7764 9.29603C11.8274 8.02064 12.1611 6.77252 12.7535 5.64189C13.3458 4.51126 14.182 3.52637 15.2016 2.75844C16.2212 1.99051 17.3986 1.45872 18.6488 1.20151C19.8991 0.944302 21.1908 0.968108 22.4308 1.27121C23.6707 1.5743 24.8277 2.14912 25.8183 2.9541C26.8089 3.75907 27.6082 4.77409 28.1585 5.92578C28.7088 7.07747 28.9963 8.33705 29.0003 9.61344C29.0012 10.7452 28.7791 11.866 28.3467 12.9118C27.9143 13.9577 27.2801 14.9081 26.4803 15.7088"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M20.3848 9.61331L23.6155 6.38257"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_3"
            d="M22.0218 19.6504L19.8679 18.918C19.6906 18.846 19.4922 18.8463 19.315 18.9187C19.1379 18.9912 18.9962 19.1301 18.9202 19.3057L17.3479 21.7396L8.73252 17.4319C8.06248 17.0478 7.31738 16.8129 6.54818 16.7434C5.77898 16.6738 5.00384 16.7712 4.27576 17.0289C3.54768 17.2866 2.88385 17.6985 2.32967 18.2364C1.77548 18.7743 1.34403 19.4256 1.06481 20.1457C1.00822 20.3296 0.988403 20.5228 1.00649 20.7143C1.02457 20.9058 1.0802 21.0919 1.17021 21.2619C1.26021 21.4319 1.38282 21.5825 1.53104 21.7051C1.67926 21.8277 1.85018 21.9199 2.03405 21.9765L7.65559 23.7857L8.21559 23.958L9.27098 27.598C9.30488 27.724 9.37002 27.8394 9.46038 27.9335C9.55074 28.0276 9.66339 28.0974 9.7879 28.1364L12.3294 28.9549C12.4612 28.9986 12.602 29.0071 12.7381 28.9796C12.8741 28.9521 13.0006 28.8896 13.105 28.7982C13.2095 28.7068 13.2883 28.5897 13.3336 28.4586C13.3788 28.3274 13.3891 28.1866 13.3633 28.0503L12.8464 25.4872L13.2125 25.5949L18.7048 27.3826C19.0648 27.5067 19.4592 27.4835 19.8021 27.3181C20.145 27.1527 20.4086 26.8584 20.5356 26.4995L22.4741 20.5334C22.5233 20.3563 22.5041 20.1672 22.4203 20.0036C22.3365 19.84 22.1942 19.7139 22.0218 19.6504Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
      </g>
    </svg>
  );
}
